import Message, {localizedMessage} from '../message/Message';

import InviteActions from '../../actions/InviteActions';
import InviteContainer from './InviteContainer';
import InviteStageStyled from './InviteStageStyled';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import SquareButton from '../squareButton/SquareButton';
import classNames from 'classnames';
import {generateRouteTo} from '../../utils/route';

class InviteStage extends React.Component {
  static propTypes = {
    inviteStore: PropTypes.object,
    loadScreen: PropTypes.node,
    isLoggedIn: PropTypes.bool,
    location: PropTypes.object,
  };

  state = {
    formInput: '',
    errorMessage: '',
  };

  componentDidMount() {
    InviteActions.getCurrentInvites(this.props.isLoggedIn);
    InviteActions.getPrevPath();
  }

  handleInput = (evt) => {
    this.setState({
      formInput: evt.target.value,
    });
  };

  handleSubmit = () => {
    // validate Email
    const email = this.state.formInput;
    const {isLoggedIn} = this.props;
    InviteActions.reset();
    if (!this.validateEmail(email)) {
      this.setState({
        errorMessage: 'epic.code.invite.error.invalid_email',
      });
    } else {
      InviteActions.sendInvite({email, isLoggedIn});
    }
  };

  handleEnterSubmit = (evt) => {
    if (evt.keyCode === 13) {
      this.handleSubmit();
    }
  };

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  render() {
    let inviteStageView;
    if (this.props.inviteStore.loading) {
      inviteStageView = this.props.loadScreen;
    } else if (!this.props.inviteStore.currentInvites) {
      const finishLink =
        this.props.inviteStore.prevPath || generateRouteTo('/', this.props.location);
      inviteStageView = (
        <div>
          <div className="site-block-header">
            <h1 className="site-block-title">
              <Message code="epic.code.invite.validate.title" />
            </h1>
            <p>
              <Message code="epic.code.invite.error.no_invites" />
            </p>
            <div className="clearfix" />
          </div>
          <div className="buttonContainer">
            <Link to={finishLink} className="btn btn-primary centered" style={{width: '240px'}}>
              <Message code="epic.common.finish" />
            </Link>
          </div>
        </div>
      );
    } else {
      const {currentInvites} = this.props.inviteStore;
      const isError = !!this.state.errorMessage || this.props.inviteStore.errorMsg;
      const errorClass = classNames('errorMessage', {hidden: !isError});
      inviteStageView = (
        <div>
          <div className="site-block-header">
            <h1 className="site-block-title">
              <Message code="epic.code.invite.send.title" />
            </h1>
            <div className="clearfix" />
          </div>
          <input
            value={this.state.formInput}
            type="text"
            placeholder={localizedMessage('epic.code.invite.validate.input_placeholder')}
            onChange={this.handleInput}
            onKeyDown={this.handleEnterSubmit}
          />
          <div className={errorClass}>
            <Message code={this.state.errorMessage} />
            {this.props.inviteStore.errorMsg && !this.state.errorMessage && (
              <Message code={this.props.inviteStore.errorMsg} />
            )}
          </div>
          <p className="text-center">
            <Message code="epic.code.invite.validate.msg" args={[currentInvites]} />
          </p>
          <div className="buttonContainer">
            <SquareButton
              handleClick={this.handleSubmit}
              config={{buttonStyle: 'btn-primary', width: '240px', centered: true}}>
              <Message code="epic.common.invite" />
            </SquareButton>
          </div>
        </div>
      );
    }

    return (
      <InviteStageStyled className="inviteStage">
        <InviteContainer className="inviteContainer">
          <h1 className="site-block-page-title">
            <Message code="epic.code.invite.title" />
          </h1>
          <div className="site-block">{inviteStageView}</div>
        </InviteContainer>
      </InviteStageStyled>
    );
  }
}

export default withRouter(InviteStage);
